<template>
	<div class="patientInfo " :class="{'patientInfo-fold': !foldTopOpen}" :style="{ height: height - 140 + 'px', width: foldTopOpen ? 'auto' : '' }">
		<div class="scrollbar">
			<img class="foldTop" :class="{'foldTopOpen': !foldTopOpen}" @click="foldTopClick" :src="foldTop" alt="">
			<div class="patientInfoContent" v-if="foldTopOpen">
				<!-- 检查信息 -->
				<div class="patientInfoContentItem">
					<foldItem ref="checkItem">
						<template #title>
							<span>检查信息</span>
						</template>
						<template #content>
							<div class="patientInfoContentItemContent">
								<div class="patientInfoContentItemContentItem">
									<el-row>
										<el-col :span="12">
											<span>检查设备：</span>
											<span>{{reportDetails && reportDetails.ExaminationInformation.Device || '--'}}</span>
										</el-col>
										<el-col :span="12">
											<span>检查日期：</span>
											<span>{{reportDetails && reportDetails.ExaminationInformation.Date || '--'}}</span>
										</el-col>
									</el-row>
								</div>
								<div class="patientInfoContentItemContentItem">
									<span>检查目的：</span>
									<span>{{ reportDetails && reportDetails.ExaminationInformation.Purpose || '--' }}</span>
								</div>
								<div class="patientInfoContentItemContentItem">
									<span>药物过敏：</span>
									<span>{{ reportDetails && reportDetails.ExaminationInformation.DrugAllergy || '--' }}</span>
								</div>
								<div class="patientInfoContentItemContentItem">
									<span>临床诊断：</span>
									<span>{{ reportDetails && reportDetails.ExaminationInformation.ClinicalDiagnosis || '--' }}</span>
								</div>
								<div class="patientInfo-line"></div>
								<div class="patientInfoContentItemContentItem">
									<span>简要病史：</span>
									<span>{{ reportDetails && reportDetails.ExaminationInformation.BriefMedicalHistory || '--' }}</span>
								</div>
								<div class="patientInfoContentItemContentItem">
									<span>相关病理结果：</span>
									<span>{{ reportDetails && reportDetails.ExaminationInformation.PathologyResults || '--' }}</span>
								</div>
								<div class="patientInfoContentItemContentItem">
									<span>相关影像及实验室检查：</span>
									<span>{{ reportDetails && reportDetails.ExaminationInformation.ImagingAndLaboratoryTests || '--' }}</span>
								</div>
								<div class="patientInfoContentItemContentItem">
									<span>既往史：</span>
									<span>{{ reportDetails && reportDetails.ExaminationInformation.PastMedicalHistory || '--' }}</span>
								</div>
							</div>
						</template>
					</foldItem>
				</div>
				<div class="patientInfo-line"></div>
				<!-- 问诊信息 -->
				<div class="patientInfoContentItem">
					<foldItem ref="consultationItem">
						<template #title>
							<span>问诊信息</span>
						</template>
						<template #content>
							<div class="patientInfoContentItemContent">
								<div class="patientInfoContentItemContentItem">
									<span>肿瘤史：</span>
									<span>{{ reportDetails && reportDetails.InqueryInformation.TurmorHistory.Summary }}，（原发部位：{{ reportDetails && reportDetails.InqueryInformation.TurmorHistory.PrimarySite || '--' }}，肿瘤类型：{{ reportDetails && reportDetails.InqueryInformation.TurmorHistory.HistlogoicalType || '--' }}）</span>
								</div>
								<div class="patientInfoContentItemContentItem">
									<span>手术史：</span>
									<span>{{ reportDetails && reportDetails.InqueryInformation.SurgicalHistory.Summary  }}，（手术部位：{{ reportDetails && reportDetails.InqueryInformation.SurgicalHistory.SurgicalSite || '--' }}，手术名称：{{ reportDetails && reportDetails.InqueryInformation.SurgicalHistory.SurgeryName || '--' }}，手术日期：{{ reportDetails && reportDetails.InqueryInformation.SurgicalHistory.SurgeryDate || '--' }}）</span>
								</div>
								<div class="patientInfoContentItemContentItem">
									<span>放化疗：</span>
									<span>{{ reportDetails && reportDetails.InqueryInformation.RadioOrChemoTherapy.Summary }}，（次数：{{ reportDetails && reportDetails.InqueryInformation.RadioOrChemoTherapy.SessionCount || '--' }}，末次治疗时间：{{ reportDetails && reportDetails.InqueryInformation.RadioOrChemoTherapy.LastTreatmentDate || '--' }}）</span>
								</div>
								<div class="patientInfoContentItemContentItem">
									<span>发热：</span>
									<span>{{ reportDetails && reportDetails.InqueryInformation.Fever }}</span>
								</div>
								<div class="patientInfoContentItemContentItem">
									<span>抗炎治疗：</span>
									<span>{{ reportDetails && reportDetails.InqueryInformation.AntiInflammatoryTreatment.Summary }}，（抗炎时间：{{ reportDetails && reportDetails.InqueryInformation.AntiInflammatoryTreatment.Duration || '--' }}）</span>
								</div>
								<div class="patientInfoContentItemContentItem">
									<span>吸烟史：</span>
									<span>{{ reportDetails && reportDetails.InqueryInformation.SmokingHistory.Summary }}，（时长：{{ reportDetails && reportDetails.InqueryInformation.SmokingHistory.Duration || '--' }}）</span>
								</div>
								<div class="patientInfoContentItemContentItem">
									<span>外伤史：</span>
									<span>{{ reportDetails && reportDetails.InqueryInformation.TraumaHistory }}</span>
								</div>
								<div class="patientInfoContentItemContentItem">
									<span>糖尿病史：</span>
									<span>{{ reportDetails && reportDetails.InqueryInformation.DiabetesHistory }}</span>
								</div>
								<div class="patientInfoContentItemContentItem">
									<span>传染病史：</span>
									<span>{{ reportDetails && reportDetails.InqueryInformation.InfectiousDiseaseHistory.Summary }}，（其他：{{ reportDetails && reportDetails.InqueryInformation.InfectiousDiseaseHistory.Notes || '--' }}）</span>
								</div>
								<div class="patientInfoContentItemContentItem">
									<span>其他系统疾病：</span>
									<span>{{ reportDetails && reportDetails.InqueryInformation.OtherSystemicDisease.Summary }}，（类型：{{ reportDetails && reportDetails.InqueryInformation.OtherSystemicDisease.Kind || '--' }}）</span>
								</div>
								<div class="patientInfoContentItemContentItem">
									<span>寄生虫病史：</span>
									<span>{{ reportDetails && reportDetails.InqueryInformation.PetParasiticDiseaseHistory.Summary }}，（是否血吸虫：{{ reportDetails && reportDetails.InqueryInformation.PetParasiticDiseaseHistory.IsSchistosoma ? "是" : "否" }}，寄生虫种类：{{ reportDetails && reportDetails.InqueryInformation.PetParasiticDiseaseHistory.Kind || '--' }}）</span>
								</div>
								<div class="patientInfoContentItemContentItem">
									<span>近期钡餐或碘造影检查：</span>
									<span>{{ reportDetails && reportDetails.InqueryInformation.RecentBariumMealOrIodineContrastExaminiation.Summary }}，（检查时间：{{ reportDetails && reportDetails.InqueryInformation.RecentBariumMealOrIodineContrastExaminiation.Date || '--' }}）</span>
								</div>
								<div class="patientInfoContentItemContentItem">
									<span>月经周期：</span>
									<span>{{ reportDetails && reportDetails.InqueryInformation.MenstrualCycle.Summary }}，（是否经期：{{ reportDetails && reportDetails.InqueryInformation.MenstrualCycle.IsCurrentlyMenstruating ? "是" : "否" }}，末次月经时间：{{ reportDetails && reportDetails.InqueryInformation.MenstrualCycle.LastMenstrualPeriod || '--' }}）	</span>
								</div>
								<div class="patientInfoContentItemContentItem">
									<span>石棉、粉尘、放射性接触及家族肿瘤史：</span>
									<span>{{ reportDetails && reportDetails.InqueryInformation.AsbestosDustRadioactiveExposureFamilyTumorHistory }}</span>
								</div>
								<div class="patientInfoContentItemContentItem">
									<el-row>
										<el-col :span="8">
											<span>WBC：</span>
											<span>{{ reportDetails && reportDetails.InqueryInformation.WBC || '--' }}</span>
										</el-col>
										<el-col :span="8">
											<span>Hb：</span>
											<span>{{ reportDetails && reportDetails.InqueryInformation.Hb || '--' }}</span>
										</el-col>
										<el-col :span="8">
											<span>ESR：</span>
											<span>{{ reportDetails && reportDetails.InqueryInformation.ESR || '--' }}</span>
										</el-col>
									</el-row>
								</div>
								<div class="patientInfoContentItemContentItem">
									<el-row>
										<el-col :span="8">
											<span>CPR：</span>
											<span>{{ reportDetails && reportDetails.InqueryInformation.CPR || '--' }}</span>
										</el-col>
										<el-col :span="8">
											<span>CEA：</span>
											<span>{{ reportDetails && reportDetails.InqueryInformation.CEA || '--' }}</span>
										</el-col>
										<el-col :span="8">
											<span>AFP：</span>
											<span>{{ reportDetails && reportDetails.InqueryInformation.AFP || '--' }}</span>
										</el-col>
									</el-row>
								</div>
								<div class="patientInfoContentItemContentItem">
									<el-row>
										<el-col :span="8">
											<span>CA199：</span>
											<span>{{ reportDetails && reportDetails.InqueryInformation.CA199 || '--' }}</span>
										</el-col>
										<el-col :span="8">
											<span>CA125：</span>
											<span>{{ reportDetails && reportDetails.InqueryInformation.CA125 || '--' }}</span>
										</el-col>
										<el-col :span="8">
											<span>CA153：</span>
											<span>{{ reportDetails && reportDetails.InqueryInformation.CA153 || '--' }}</span>
										</el-col>
									</el-row>
								</div>
								<div class="patientInfoContentItemContentItem">
									<el-row>
										<el-col :span="8">
											<span>CA724：</span>
											<span>{{ reportDetails && reportDetails.InqueryInformation.CA724 || '--' }}</span>
										</el-col>
										<el-col :span="8">
											<span>PSA：</span>
											<span>{{ reportDetails && reportDetails.InqueryInformation.PSA || '--' }}</span>
										</el-col>
										<el-col :span="8">
											<span>NSE：</span>
											<span>{{ reportDetails && reportDetails.InqueryInformation.NSE || '--' }}</span>
										</el-col>
									</el-row>
								</div>
								<div class="patientInfoContentItemContentItem">
									<el-row>
										<el-col :span="8">
											<span>结核菌素试验：</span>
											<span>{{ reportDetails && reportDetails.InqueryInformation.TuberculinTest || '--' }}</span>
										</el-col>
										<el-col :span="8">
											<span>隐球菌试验：</span>
											<span>{{ reportDetails && reportDetails.InqueryInformation.CryptococcusTest || '--' }}</span>
										</el-col>
										<el-col :span="8">
											<span>痰涂片：</span>
											<span>{{ reportDetails && reportDetails.InqueryInformation.SputumSmear || '--' }}</span>
										</el-col>
									</el-row>
								</div>
								<div class="patientInfoContentItemContentItem">
									<span>辅助检查：</span>
									<span>{{ reportDetails && reportDetails.InqueryInformation.AdditionalExamination || '--' }}</span>
								</div>
							</div>
						</template>
					</foldItem>
				</div>
				<div class="patientInfo-line"></div>
				<!-- 附加图片 -->
				<div class="patientInfoContentItem">
					<foldItem ref="imagesItem">
						<template #title>
							<span>附加图片（{{reportDetails.AttachedPictures.length || 0}}）</span>
						</template>
						<template #titleMore>
							<div class="patientInfoContentItemTitleMore" @click="onShowMoreImages">
								展开更多
								<i class="el-icon-more" style="transform: rotateZ(90deg);"></i>
							</div>
						</template>
						<template #content>
							<div class="patientInfoContentItemContent img-list-box" v-if="reportDetails && reportDetails.AttachedPictures && reportDetails.AttachedPictures.length > 0">
								<div class="patientInfoContentItemContentItem img-list" v-for="(item,index) in reportDetails.AttachedPictures" :key="index" @click="onShowMoreImages">
									<img :src="item.Address" alt="" class="patientInfoContentItemContentItemImg">
									<div class="patientInfoContentItemContentItemDesc">{{item.Notes || '--'}}</div>
								</div>
							</div>
						</template>
					</foldItem>
				</div>
				<div class="patientInfo-line"></div>
				<!-- 注射信息 -->
				<div class="patientInfoContentItem">
					<foldItem ref="injectionItem">
						<template #title>
							<span>注射信息</span>
						</template>
						<template #content>
							<div class="patientInfoContentItemContent">
								<div class="patientInfoContentItemContentItem">
									<el-row>
										<el-col :span="12">
											<span>空腹血糖：</span>
											<span>{{ reportDetails && reportDetails.InjectionInformation.FastingBloodGlucose || '--' }}mmol/L</span>
										</el-col>
										<el-col :span="12">
											<span>是否增强：</span>
											<span>{{ reportDetails && reportDetails.InjectionInformation.IsEnhanced || '--' }}</span>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<span>放射药物：</span>
											<span>{{ reportDetails && reportDetails.InjectionInformation.Radiopharmaceutical || '--' }}</span>
										</el-col>
										<el-col :span="12">
											<span>半衰期（min）：</span>
											<span>{{ reportDetails && reportDetails.InjectionInformation.HalfLifeMinutes || '--' }}min</span>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<span>注射类型：</span>
											<span>{{ reportDetails && reportDetails.InjectionInformation.InjectionType || '--' }}</span>
										</el-col>
										<el-col :span="12">
											<span>注射部位：</span>
											<span>{{ reportDetails && reportDetails.InjectionInformation.InjectionSite || '--' }}</span>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<span>注射护士：</span>
											<span>{{ reportDetails && reportDetails.InjectionInformation.InjectingNurse || '--' }}</span>
										</el-col>
										<el-col :span="12">
											<span>满针剂量：</span>
											<span>{{ reportDetails && reportDetails.InjectionInformation.FullSyringeDose || '--' }}mCi</span>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<span>测量时间：</span>
											<span>{{ reportDetails && reportDetails.InjectionInformation.MeasurementTime || '--' }}</span>
										</el-col>
										<el-col :span="12">
											<span>空针剂量：</span>
											<span>{{ reportDetails && reportDetails.InjectionInformation.EmptySyringeDose || '--' }}mCi</span>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<span>空针时间：</span>
											<span>{{ reportDetails && reportDetails.InjectionInformation.EmptySyringeTime || '--' }}</span>
										</el-col>
										<el-col :span="12">
											<span>注射剂量：</span>
											<span>{{ reportDetails && reportDetails.InjectionInformation.InjectionDose || '--' }}mCi</span>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="24">
											<span>注射时间：</span>
											<span>{{ reportDetails && reportDetails.InjectionInformation.InjectionTime || '--' }}</span>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<el-checkbox class="patientInfoContentItemContentItemCheckbox" v-model="reportDetails.InjectionInformation.IsIndwellingNeedleInjection">留置针注射</el-checkbox>
										</el-col>
										<el-col :span="12">
											<el-checkbox class="patientInfoContentItemContentItemCheckbox" v-model="reportDetails.InjectionInformation.IsExtravasation">渗透</el-checkbox>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="24">
											<el-checkbox class="patientInfoContentItemContentItemCheckbox" v-model="reportDetails.InjectionInformation.IsInjectionReaction">注射反应：</el-checkbox>
											<!-- <span></span> -->
										</el-col>
									</el-row>
								</div>
							</div>
						</template>
					</foldItem>
				</div>
				<div class="patientInfo-line"></div>
				<!-- 基础信息 -->
				<div class="patientInfoContentItem">
					<foldItem ref="basicItem">
						<template #title>
							<span>基础信息</span>
						</template>
						<template #content>
							<div class="patientInfoContentItemContent">
								<div class="patientInfoContentItemContentItem">
									<el-row>
										<el-col :span="12">
											<el-checkbox class="patientInfoContentItemContentItemCheckbox" v-model="reportDetails.InjectionBasicInformation.SuspectedContamination.IsOn">可疑污染（部位：{{ reportDetails && reportDetails.InjectionBasicInformation.SuspectedContamination.Site }}）：</el-checkbox>
										</el-col>
										<el-col :span="12">
											<span>特殊注射方式：</span>
											<span>{{ reportDetails && reportDetails.InjectionBasicInformation.SpecialInjectionMethod || '--' }}</span>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="24">
											<span>饮水情况：</span>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="24" v-for="(item,index) in reportDetails.InjectionBasicInformation.WaterConsumptions">
											<el-checkbox class="patientInfoContentItemContentItemCheckbox" v-model="item.IsNotTaken">
												末饮{{ index >=1 ? index : ''}}（{{reportDetails.InjectionBasicInformation.WaterConsumptions.Volume || '--'}}ml，时间：{{reportDetails.InjectionBasicInformation.WaterConsumptions.Time || '--'}}）
											</el-checkbox>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="24">
											<span>利尿剂：</span>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="24">
											<el-checkbox class="patientInfoContentItemContentItemCheckbox" v-model="reportDetails.InjectionBasicInformation.DiureticOral.IsOn">
												口服（{{reportDetails.InjectionBasicInformation.DiureticOral.Volume || '--'}}ml，时间：{{reportDetails.InjectionBasicInformation.DiureticOral.Time || '--'}}）
											</el-checkbox>
											<el-checkbox class="patientInfoContentItemContentItemCheckbox" v-model="reportDetails.InjectionBasicInformation.DiureticInjection.IsOn">
												静脉注射（{{reportDetails.InjectionBasicInformation.DiureticInjection.Volume || '--'}}ml，时间：{{reportDetails.InjectionBasicInformation.DiureticInjection.Time || '--'}}）
											</el-checkbox>
										</el-col>
									</el-row>
								</div>
							</div>
						</template>
					</foldItem>
				</div>
				<div class="patientInfo-line"></div>
				<!-- 检查参数及辐射剂量 -->
				<div class="patientInfoContentItem">
					<foldItem ref="parametersItem">
						<template #title>
							<span>检查参数及辐射剂量</span>
						</template>
						<template #content>
							<div class="patientInfoContentItemContent">
								<div class="patientInfoContentItemContentItem" v-if="reportDetails && reportDetails.InspectionDoseParameters && reportDetails.InspectionDoseParameters.Samples && reportDetails.InspectionDoseParameters.Samples.length > 0">
									<el-row>
										<el-col :span="24" v-for="item in reportDetails.InspectionDoseParameters.Samples">
											<span>
												采集时间（时间：{{ item.checkTime || '--' }},部位：{{item.part || '--'}}，床位：{{item.bed || '--'}}，床位数：{{item.BedsCount || '--'}}）
											</span>
										</el-col>
									</el-row>
								</div>
								<div class="patientInfoContentItemContentItem">
									<el-row>
										<el-col :span="12">
											<span>CTDlvol（mGy）：</span>
											<span>{{ reportDetails && reportDetails.InspectionDoseParameters.CTDlvol || '--' }}</span>
										</el-col>
										<el-col :span="12">
											<span>Total（mAs）：</span>
											<span>{{ reportDetails && reportDetails.InspectionDoseParameters.Total || '--' }}</span>
										</el-col>
									</el-row>
								</div>
								<div class="patientInfoContentItemContentItem">
									<el-row>
										<el-col :span="12">
											<span>DLP（mGy）：</span>
											<span>{{ reportDetails && reportDetails.InspectionDoseParameters.DLP || '--' }}</span>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<span>操作技师：</span>
											<span>{{ reportDetails && reportDetails.InspectionDoseParameters.Operator || '--' }}</span>
										</el-col>
									</el-row>
								</div>
							</div>
						</template>
					</foldItem>
				</div>
				<div class="patientInfo-line"></div>
				<!-- 延迟显像 -->
				<div class="patientInfoContentItem">
					<foldItem ref="delayItem">
						<template #title>
							<span>延迟显像</span>
						</template>
						<template #content>
							<div class="patientInfoContentItemContent">
								<div class="patientInfoContentItemContentItem">
									<el-row>
										<el-col :span="24">
											<el-radio class="patientInfoContentItemContentItemRadio" v-model="reportDetails.DelayImaging.IsLargeAmountDrinkingAndUrination" label="1">大量饮水、排尿</el-radio>
										</el-col>
										<el-col :span="24">
											<el-radio class="patientInfoContentItemContentItemRadio" v-model="reportDetails.DelayImaging.IsDrinkingUrinationRetention" label="1">饮水、排尿、憋尿</el-radio>
										</el-col>
										<el-col :span="24">
											<el-radio class="patientInfoContentItemContentItemRadio" v-model="reportDetails.DelayImaging.IsDrinkingBeforeImaging" label="1">上机前饮水</el-radio>
										</el-col>
										<el-col :span="24">
											<el-radio class="patientInfoContentItemContentItemRadio" v-model="reportDetails.DelayImaging.IsOther" label="1">其他：{{ reportDetails.DelayImaging.OthersLabel || '--' }}</el-radio>
										</el-col>
									</el-row>
									<template v-if="reportDetails && reportDetails.DelayImaging && reportDetails.DelayImaging.Samples && reportDetails.DelayImaging.Samples.length > 0">
										<el-row v-for="item in reportDetails.DelayImaging.Samples">
											<el-col :span="24">
												<el-checkbox class="patientInfoContentItemContentItemCheckbox" v-model="item.IsOn">采集时间（时间：{{ item.checkTime || '--' }},部位：{{ item.part || '--' }}，床位：{{ item.bed || '--' }}，床位数：{{ item.BedsCount || '--' }}）</el-checkbox>
											</el-col>
										</el-row>
									</template>
									<el-row>
										<el-col :span="24">
											<span>技师：{{ reportDetails.DelayImaging.Operator || '--' }}</span>
										</el-col>
									</el-row>
								</div>
							</div>
						</template>
					</foldItem>
				</div>
			</div>
			<div class="patientInfoContent-fold" v-else>
				<div class="patientInfoContent-fold-item" @click="toggleItem('check')">
					<img :src="jianchaxinxi" alt="">
					<span>检查信息</span>
				</div>
				<div class="patientInfoContent-fold-item" @click="toggleItem('consultation')">
					<img :src="wenzhenxinxi" alt="">
					<span>问诊信息</span>
				</div>
				<div class="patientInfoContent-fold-item" @click="toggleItem('images')">
					<img :src="ohterImg" alt="">
					<span>附加图片</span>
				</div>
				<div class="patientInfoContent-fold-item" @click="toggleItem('injection')">
					<img :src="zhushexinxi" alt="">
					<span>注射信息</span>
				</div>
				<div class="patientInfoContent-fold-item" @click="toggleItem('basic')">
					<img :src="jichuxinxi" alt="">
					<span>基础信息</span>
				</div>
				<div class="patientInfoContent-fold-item" @click="toggleItem('parameters')">
					<img :src="jianchacanshu" alt="">
					<span>检查参数</span>
				</div>
				<div class="patientInfoContent-fold-item" @click="toggleItem('delay')">
					<img :src="yanchixianxiang" alt="">
					<span>延迟显像</span>
				</div>
			</div>
		</div>
		<div class="patientInfo-congfig-bottom">
			<span class="patientInfo-congfig-bottom-text">自动展开</span>
			<el-switch v-model="autoExpand" @change="handleAutoExpandChange">
			</el-switch>
		</div>
		<view-img-dialog
			:visible.sync="imgDialogVisible"
			:list="imgList"
		/>
	</div>
</template>

<script>
import foldTop from '../assets/images/dark/scoring/fold-top.png'
import jianchaxinxi from '../assets/images/dark/scoring/jianchaxinxi.png'
import jianchacanshu from '../assets/images/dark/scoring/jianchacanshu.png'
import jichuxinxi from '../assets/images/dark/scoring/jichuxinxi.png'
import wenzhenxinxi from '../assets/images/dark/scoring/wenzhenxinxi.png'
import yanchixianxiang from '../assets/images/dark/scoring/yanchixianxiang.png'
import zhushexinxi from '../assets/images/dark/scoring/zhushexinxi.png'
import ohterImg from '../assets/images/dark/scoring/ohterImg.png'
import foldItem from './foldItem.vue'
import viewImgDialog from './viewImgDialog.vue'
// import Vuex from 'vuex'
export default {
	name: 'patientInfo',
	components: {
		foldItem,
		viewImgDialog,
	},
	data() {
		return {
			autoExpandConfig: false,
			foldTop,
			jianchaxinxi,
			jianchacanshu,
			jichuxinxi,
			wenzhenxinxi,
			yanchixianxiang,
			zhushexinxi,
			ohterImg,
			foldTopOpen: true,
			height: `${document.documentElement.clientHeight}`,
			autoExpand: false,
			checked: false,
			radio: '1',
			activeItem: null, // 当前激活的项
			imgDialogVisible: false,
			imgList: [],
		}
	},
	computed: {
		...Vuex.mapState("doctor", ["reportDetails"]),
	},
	activated() {
		this.autoExpandConfig = localStorage.getItem('autoExpandConfig') == 'true' ? true : false
		// 根据后端配置设置初始折叠状态
		this.foldTopOpen = this.autoExpandConfig
		// 同步autoExpand状态
		this.autoExpand = this.autoExpandConfig
		// 向父组件发送初始折叠状态
		this.$emit('fold-change', !this.foldTopOpen)
		console.log(this.reportDetails,'reportDetails')
	},
	mounted() {
		
	},
	watch: {
		// 监听后端配置变化
		autoExpandConfig: {
			handler(newVal) {
				this.foldTopOpen = newVal
				this.autoExpand = newVal
				this.$emit('fold-change', !this.foldTopOpen)
			},
			immediate: true
		}
	},
	methods: {
		foldTopClick() {
			this.foldTopOpen = !this.foldTopOpen
			// 向父组件发送折叠状态变化事件
			this.$emit('fold-change', !this.foldTopOpen)
			// 如果展开，清除激活项
			if (this.foldTopOpen) {
				this.activeItem = null
			}
		},
		// 切换单个项
		toggleItem(itemType) {
			// 展开整个组件
			this.foldTopOpen = true
			this.$emit('fold-change', false)
			
			// 设置激活项
			this.activeItem = itemType
			
			// 在下一个tick中控制foldItem的展开状态
			this.$nextTick(() => {
				// 先关闭所有foldItem
				this.closeAllFoldItems()
				// 然后打开对应的foldItem
				this.openSpecificFoldItem(itemType)
			})
		},
		// 关闭所有foldItem
		closeAllFoldItems() {
			const foldItems = ['checkItem', 'consultationItem', 'imagesItem', 'injectionItem', 'basicItem', 'parametersItem', 'delayItem']
			foldItems.forEach(itemRef => {
				if (this.$refs[itemRef]) {
					this.$refs[itemRef].isOpen = false
				}
			})
		},
		// 打开特定的foldItem
		openSpecificFoldItem(itemType) {
			const itemRefMap = {
				'check': 'checkItem',
				'consultation': 'consultationItem',
				'images': 'imagesItem',
				'injection': 'injectionItem',
				'basic': 'basicItem',
				'parameters': 'parametersItem',
				'delay': 'delayItem'
			}
			
			const refName = itemRefMap[itemType]
			if (refName && this.$refs[refName]) {
				this.$refs[refName].isOpen = true
			}
		},
		onShowMoreImages() {
			// 假设 this.images 是你的图片数组
			this.imgList = this.reportDetails.AttachedPictures.map(item => {
				return {
					id: item.Id,
					url: item.Address,
					desc: item.Notes 
				}
			})
			this.imgDialogVisible = true
		},
		handleAutoExpandChange(value) {
			localStorage.setItem('autoExpandConfig', value)
		}
	}
}
</script>

<style scoped lang="scss">
@import '../assets/style/variables.scss';
@import '../assets/style/mixin.scss';
.scrollbar{
	height: 100%;
	overflow-y: auto;
	scrollbar-width: none;
	padding-bottom: 30px;
	&::-webkit-scrollbar{
		display: none;
	}
	// padding:0px 0px 80px 0px;
}
.patientInfo {
	@include bg-color(titleBg);
	// background: #282B32;
	border-radius: 4px;
	position: relative;
	box-sizing: border-box;
	padding:68px 16px 42px 16px;
	transition: width 0.3s ease;
	
	.foldTop {
		position: absolute;
		right:16px;
		top:24px;
		cursor: pointer;
		width: 20px;
		height: 20px;
		transition: transform 0.3s ease;
	}
	.foldTopOpen{
		right:38px;
		top:23px;
		transform: rotate(180deg);
	}
	
	.patientInfoContentItemContentItem {
		margin-bottom: 8px;
		span {
			font-weight: 400;
			font-size: 12px;
			// color: #FFFFFF;
			line-height: 20px;
			// text-shadow: 0px 2px 4px rgba(0,0,0,0.5);
		}
		
	}
	.patientInfoContentItemContentItem:last-child{
		margin-bottom: 0;
	}
	.patientInfo-line{
		height: 1px;
		background: #3D4049;
		margin:24px 0;
	}
	.patientInfoContentItemContentItemCheckbox{
		::v-deep .el-checkbox__input.is-checked+.el-checkbox__label{
			// color:#ffffff;
			@include text-color(fzColor);
			font-size: 12px;
		}
		::v-deep .el-checkbox__label{
			// color:#ffffff;
			@include text-color(fzColor);
			font-size: 12px;

		}
	}
	.patientInfoContentItemContentItemRadio{
		::v-deep .el-radio__input.is-checked+.el-radio__label{
			@include text-color(fzColor);
			font-size: 12px;
		}
		::v-deep .el-radio__label{
			@include text-color(fzColor);
			font-size: 12px;
		}
	}
	.patientInfo-congfig-bottom{
		z-index: 100;
		@include bg-color(titleBg);
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		width: 100%;
		height: 40px;
		// box-shadow: 0px -8px 4px 0px rgba(0,0,0,0.12);
		display: flex;
		align-items: center;
		padding:0 16px;
		box-sizing: border-box;
		.patientInfo-congfig-bottom-text{
			font-size: 12px;
			color: #248AFD;
			margin-right: 10px;
		}
	}
	.patientInfoContent-fold{
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 20px 0;
		
		.patientInfoContent-fold-item{
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			width: 72px;
			height: 66px;
			cursor: pointer;
			@include bg-color(bodyBg);
			border-radius: 8px;
			margin-bottom: 8px;
			transition: all 0.3s ease;
			
			&:hover {				
				background: rgba(36,138,253,0.16);
				border: 1px solid #248AFD;
			}
			
			
			img{
				width: 16px;
				height: 16px;
				margin-bottom: 12px;
			}
			span{
				// @include text-color(breadcrumbColor);
				color: #248AFD;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 14px;
			}
		}
	}
	.img-list-box{
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		// flex-wrap: wrap;
		// gap: 16px;
		.img-list{
		display: flex;
		flex-direction: column;
		align-items: center;
		.patientInfoContentItemContentItemImg{
			width: 100px;
			height: 100px;
			border-radius: 6px;
			border: 1px solid #3D4049;
			object-fit: cover;
			margin-bottom: 8px;
		}
		.patientInfoContentItemContentItemDesc{
			@include text-color(fzColor);
			font-weight: 400;
			font-size: 14px;
		}
	}
	}
}
.patientInfo-fold{
	padding:68px 12px 42px 12px;
	.patientInfo-congfig-bottom{
		// padding:0;
		.patientInfo-congfig-bottom-text{
			margin-right: 4px !important;
		}
	}
}
</style>